
import React, { useEffect, useState } from 'react';
import { Animated, Image, ScrollView, StyleSheet,TouchableOpacity, View } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import { AssistanceItem } from '../AssistanceItem';
import { AssistanceItemNew } from '../AssistanceItemNew';

import { observer } from 'mobx-react';

import CompanyOwnRessources from '../CompanyOwnRessource/CompanyOwnRessource';
import Images from '../../../state/stores/Image/images';
import PressableScale from '../../PressableScale/PressableScale';
import Show from '../../Show/Show';
import { AssistanceStackParamList } from '../../../types/navigation';
import { BOTTOM_SPACING_SCROLLVIEW } from '../../../config/designSystem/Spacing';
import { BasicModalFeedback } from '../../Modal/BasicModalFeedback';
import { COLORS, GRAY_BACKGROUND,  MAX_WIDTH } from '../../../config/designSystem/Colors';
import { Collapsable } from '../../Collapsable/Collapsable';
import { CollapsableWithRedoButton } from '../../Collapsable/CollapsableWithRedoButton';
import { GET_REDO_SESSION } from '../../../state/queries/Session';
import { MATCHING_SURVEY } from '../../../state/queries/Survey';
import { ParagraphLBold, ParagraphMBold, ParagraphMRegular, ParagraphSRegular } from '../../../config/designSystem/typography';
import { REGULAR_HORIZONTAL_MARGIN_FN, REGULAR_MARGIN_VERTICAL_FN, SMALL_MARGIN_VERTICAL_FN, WEB_HORIZONTAL_MARGIN_FN, WIDTH_PSYCHO_CARD, isWeb } from '../../../config/designSystem/Layout';
import { SET_NOT_ACTIVE } from '../../../state/mutations/UserMatching';
// Local Title, NOT react-native-paper's: this call site uses the local API
// (legacy/title/withBack/size). The paper import silently rendered an empty
// header because paper's Title takes children, not a `title` prop.
import Title from '../../Title/Title';
import { branchingKey, helpdeskKey, organizationAssistanceKey, psychologistDetailKey, sessionStackKey } from '../../../constants/routeKeys';
import { client } from '../../../config/apollo/client';
import { concatPath } from '../../../utils/links/concatPath';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { router, useScrollToTop } from 'expo-router';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useMutation } from '@apollo/client';
import { useNavigation } from 'expo-router/react-navigation';
import { useStores } from '../../../hooks/useStores';


type LegacyAssistanceProps = AssistanceStackParamList['Assistance'];

export const LegacyAssistance: React.FunctionComponent<LegacyAssistanceProps> = observer(() => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.ASSISTANCE;
  const assistanceData = rootStore?.user?.company;
  const [survey, surveyChange] = React.useState('');
  const { height, width } = useAvailableDimensions();
  const WIDTH_VIEW = Math.min(MAX_WIDTH, width - 2 * REGULAR_MARGIN_VERTICAL_FN(width));

  const psycho = rootStore?.psychologist?.getMatchings;
  const psychoFound = rootStore?.psychologist?.isFound;
  const isManualMatchingSearchActive = rootStore?.psychologist?.isManualMatchingSearchActive;
  const matchingSurveyDone = rootStore?.user?.user?.matchingSurveyDone;
  const [isVisible, setIsVisible] = useState(false);
  const pricingQuestion = rootStore?.user?.company?.pricingQuestion;
  const assistanceInfo = rootStore?.user?.company?.assistanceInfo;
  const [setNotActiveMutation] = useMutation(SET_NOT_ACTIVE);

  const ref = React.useRef(null);
  const ref2 = React.useRef(null);
  const navigation = useNavigation();
  useScrollToTop(ref);
  useScrollToTop(ref2);

  const notSatisfied = {
    firstName: labels?.NOT_SATISFIED_MATCH,
    psychoTitle: labels?.NOT_SATISFIED_MATCH_CONTENT,
    profileImage: '',
    _id: '',
    lastName: '',
    background: { backgroundName: 'background0' },
  };

  const psychoWithNotFound = psycho.concat(notSatisfied);

  const WIDTH_FOR_SNAP = WIDTH_PSYCHO_CARD(width) + 2 * REGULAR_HORIZONTAL_MARGIN_FN(width * 2);



  const colors = [
    '#D1E7FB',
    '#FFD5C8',
    '#D2EFE8',
    '#E8E8E8',
  ];


  const Backgrounds = [
    'background0',
    'background1',
    'background2',
    'background3',
  ];

  const goToSession = (sessionId: string) => {
    router.navigate({
      pathname: concatPath([sessionStackKey,branchingKey], 3) as string,
      params: {
        sessionId,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false),
      }});
  };

  // the matching is a session: launched by type
  const goToSurvey = async (_surveyId?: string) => {
    const sessionId = await rootStore.session.fetchSessionIdOfType('matching');
    if (!sessionId) {
      console.warn('No matching session');
      return;
    }
    router.navigate({
      pathname: concatPath([sessionStackKey,branchingKey], 3) as string,
      params: {
        sessionId,
        reckoningId: null,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false),
      }});
  };

  const goToPsychologistDetail = (psychologistId: string, index: number) => {
    router.navigate({
      pathname: concatPath([psychologistDetailKey], 2) as string,
      params: {
        _id: psychologistId,
        background: Backgrounds[index],
        backgroundColor: encodeURIComponent(colors[index]),
      }});
  };


  const goToOrganizationKey = () => {
    router.navigate(concatPath([organizationAssistanceKey],2));
  };






  const [sessionId, setSessionId] = React.useState<string>('');



  useEffect(() => {
    getMatchingSurvey();
    getRedoSession();
  }, []);


  const getMatchingSurvey = async () => {
    const { data } = await client.query({ query: MATCHING_SURVEY });
    if (data && 'matchingSurvey' in data) {
      surveyChange(data.matchingSurvey._id);
    }
  };

  const getRedoSession = async () => {
    const { data } = await client.query({ query: GET_REDO_SESSION });
    if (data && 'redoSession' in data) {
      setSessionId(data?.redoSession?._id);
    }
  };



  const onPressOrganizationAssistance = () => {
    if (!rootStore.user?.user?.onboardingDone && !rootStore.user?.user?.redoSessionDone && !!sessionId && rootStore?.user?.company?.withRedoSession) {
      goToSession(sessionId);
    } else {
      goToOrganizationKey();
    }
  };





  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      rootStore?.psychologist.fetchPsychologists();
    });
    return unsubscribe;
  }, [navigation]);

  const onCancelPress = async () => {
    await setNotActiveMutation();
    rootStore.psychologist.fetchPsychologists();
  };



  const callOnDismissModal = () => {
    rootStore.psychologist.fetchPsychologists();
    setIsVisible(false);
  };


  // Render all psychologists card and the last not satisfied card. If you click on psychologists card you go to their profile. If you click on the satisfied card pop message is shown.
  const renderItem = React.useCallback(({ item, index }) => {
    let imageData: any = {
      fromStore: false,
      uri: item.profileImage,
      size: 70
    };
    const isNotFound = item === psychoWithNotFound[psychoWithNotFound.length - 1];
    if (isNotFound) {
      imageData = {
        fromStore: true,
        storeName: 'assistance',
        imageName: 'ghostImage',
        uri: null,
        size: 70
      };
    }
    const onPress = async () => {

      if (isNotFound) {
        setIsVisible(true);
      } else {
        goToPsychologistDetail(item._id, index);
        setIsVisible(false);
      }
    };
    const itemProp = {
      title: item.firstName + ' ' + item.lastName,
      description: item.psychoTitle ? item.psychoTitle : '',
      image: imageData,
      secondImage: item.inContact ? 'user' : 'star',
      logo: {
        type: 'none',
      },
      background: Backgrounds[index],
      backgroundColor: colors[index],
      onPress,
      isNotFound
    };

    return <AssistanceItemNew item={itemProp} />;
  }, [psychoWithNotFound, width]);

  const goToHelpDesk = () => {
    router.navigate(concatPath([helpdeskKey],2));
  };


  // To navigate in the Help Desk screen


  // Navigate to Own Assistance of the company.




  // Navigate to matching survey
  const onPressTakeSurvey = (firstTime: boolean) => {
    logAmplitude('Evoluno Matching Survey Taken', { firstTime });
    if(survey) {
      goToSurvey(survey);
    }
  };
  const scaleAnimation = React.useRef(new Animated.Value(1)).current;
  const ROW_GAP = 10;
  const LEFT = 18;
  const MARGIN_VERTICAL = 15;

  const titleAndExplanation = (title: string, explanation: string) => {
    return (
      <View style={{ left: LEFT,
        rowGap: ROW_GAP,
        marginVertical: MARGIN_VERTICAL,
        width: '90%',
      }}>
        <ParagraphLBold>{title}</ParagraphLBold>
        <ParagraphMRegular flexWrap={true}>{explanation}</ParagraphMRegular>
      </View>
    );
  };

  // Getting the views of which state we are
  const SIZE = 50;
  const PADDING_HORIZONTAL_PLUS = 20;


  return (
    <View style={{flex:1, paddingTop:!isWeb?30:0}}>
      <Title
        legacy
        title={labels?.NAVIGATION_TITLE}
        withBack={false}
        color={COLORS.brand[500] }
        size={34}
      />
      {<BasicModalFeedback isVisible={isVisible} setIsVisible={setIsVisible} onDismiss={() => { callOnDismissModal(); }} mainText={labels?.NOT_SATISFIED_MATCH_FEEDBACK_TEXT} buttonText={labels?.NOT_SATISFIED_MATCH_BUTTON} />}

      <ScrollView contentContainerStyle={[isWeb &&
      {
        flex: 1,
        marginTop: SMALL_MARGIN_VERTICAL_FN(height), marginHorizontal: WEB_HORIZONTAL_MARGIN_FN(width) / 3.5
      }, !isWeb && {paddingBottom: BOTTOM_SPACING_SCROLLVIEW}]
      }
      ref={ref}
      >
        {assistanceData?.hasAccessToEvolunoAssistance&& (<>
          {((!psychoFound || psychoFound == null) && !isManualMatchingSearchActive) && (<>
            {titleAndExplanation(labels?.FIND_THERAPIST_TITLE, labels?.FIND_THERAPIST_DESCRIPTION)
            }</>)}
          {(psychoFound) && (<>
            {titleAndExplanation(labels?.MATCH_TITLE, labels?.MATCH_DESCRIPTION)
            }</>)}
          {(!psychoFound && isManualMatchingSearchActive) && (<>
            {titleAndExplanation(labels?.NOT_MATCH_TITLE, labels?.NOT_MATCH_DESCRIPTION)
            }</>)}


          {(!psychoFound || psychoFound == null) && !isManualMatchingSearchActive &&
          <PressableScale scaleAnimation={scaleAnimation} >
            <Animated.View style={[
              {
                transform: [{ scale: scaleAnimation }],
                width:WIDTH_VIEW
              },
              {
                borderRadius: 20,
              },
              isWeb && {
                shadowRadius: 5,
                shadowOffset: {
                  width: 0.1,
                  height: 0.1,
                },
                elevation: 8,
                width: '70vw',
                shadowOpacity: 0.2,
                borderRadius: 20,
                overflow: 'hidden',
              },
            ]} >
              <View style={{flex:1, width: '100%', backgroundColor:GRAY_BACKGROUND, borderRadius: 20}}>
                <TouchableOpacity onPress={() => onPressTakeSurvey(true)}
                  style={[{flexDirection: 'row',
                    paddingVertical: 10,
                    paddingHorizontal: PADDING_HORIZONTAL_PLUS,
                    alignItems:'center'}, isWeb && { borderRadius: 15}]}>
                  <View style={[ {position: 'absolute', left:20}]}>
                    <AntDesign name='plus-circle' color={COLORS.brand[500] } size={SIZE}/>
                  </View >
                  <View style={[{rowGap:10, justifyContent:'center',
                    marginLeft:SIZE+PADDING_HORIZONTAL_PLUS, width:'70%'}]}>
                    <View>
                      <ParagraphMBold  >
                        {labels?.FIND_THERAPIST_SUBTITLE}
                      </ParagraphMBold>
                    </View>
                    <View>
                      <ParagraphSRegular >{labels?.FIND_THERAPIST_SUBDESCRIPTION}
                      </ParagraphSRegular>
                    </View>
                  </View>

                </TouchableOpacity>
                <Image
                  source={Images.assistance.background2} style={{width: 80, height:80, right:0,bottom:0, position:'absolute'}} />

              </View>
            </Animated.View>
          </PressableScale>
          }
          {!psychoFound && isManualMatchingSearchActive && <TouchableOpacity style={styles.glassContainer}>
            <Image source={Images.assistance.magnifying_class} style={styles.glass}  />
          </TouchableOpacity>}

          {psychoFound && <View style={[ !isWeb && { marginTop: SMALL_MARGIN_VERTICAL_FN(height) }]}>
            <View >
              <View >
                {isWeb ?
                  <View>
                    <TouchableOpacity>
                      <Animated.FlatList
                        data={psychoWithNotFound}
                        keyExtractor={item => item._id}
                        renderItem={renderItem}
                        pagingEnabled
                        showsHorizontalScrollIndicator={false}
                        contentContainerStyle={{ flexGrow: 1 }}
                        ref={ref2}
                      />
                    </TouchableOpacity>
                  </View> : <TouchableOpacity style={{flex:1}}>
                    <Animated.FlatList
                      data={psychoWithNotFound}
                      keyExtractor={item => item._id}
                      renderItem={renderItem}
                      ref={ref2}
                      horizontal
                      showsHorizontalScrollIndicator={false}
                      snapToInterval={WIDTH_FOR_SNAP}
                      snapToAlignment="start"
                      decelerationRate="fast"
                    />
                  </TouchableOpacity>}
              </View>
            </View>
          </View>}
          <View style={{marginTop: 20}}>

            {!matchingSurveyDone &&
          <><Collapsable
            headerOne={labels?.DEFAULT_COLLAPSABLE_HEADER_ONE}
            contentOne={labels?.DEFAULT_COLLAPSABLE_CONTENT_ONE} />
          <Collapsable
            headerOne={pricingQuestion}
            contentOne={assistanceInfo} /></>
            }

            {(psychoFound && !isManualMatchingSearchActive &&
          <><CollapsableWithRedoButton
            title={labels?.MATCH_COLLAPSABLE_WITH_REDO_BUTTON_HEADER}
            content={labels?.MATCH_COLLAPSABLE_WITH_REDO_BUTTON_CONTENT}
            button={labels?.MATCHING?.REDO}
            onPress={() => onPressTakeSurvey(false)}
          />
          <Collapsable
            headerOne={pricingQuestion}
            contentOne={assistanceInfo} /></>
            )}

            {(!psychoFound && isManualMatchingSearchActive &&
          <CollapsableWithRedoButton
            title={labels?.CANCEL_REQUEST_HEADER}
            content={labels?.CANCEL_REQUEST_CONTENT}
            button={labels?.CANCEL_REQUEST_CONFIRM_BUTTON}
            onPress={() => { onCancelPress(); }}
          />


            )}
          </View>
        </>)}

        {assistanceData?.hasAccessToEvolunoAssistance && (

          <View style={{ left: LEFT, marginVertical: MARGIN_VERTICAL}}>
            <ParagraphLBold>{labels?.OTHER_RESOURCES} </ParagraphLBold>
          </View>)}


        <Show when={assistanceData?.hasAccessToOwnAssistance}>
          <Show when={!assistanceData?.hasAccessToEvolunoAssistance} fallback={
            <AssistanceItem
              onPress={onPressOrganizationAssistance}
              title={assistanceData?.ownAssistanceTitle || labels?.TITLE_INTERNAL}
              text={assistanceData?.ownAssistanceText || labels?.SUBTITLE_INTERNAL}
              hasIconInternal={true}
              hasIconEvoluno={false}
              backgroundColor={assistanceData?.ownAssistanceColor|| '#D8B6F2'}
            />
          }
          >
            <CompanyOwnRessources errorMessageIfNone={false}/>
          </Show>
        </Show>

        <AssistanceItem
          title={labels?.TITLE_EVO_HELP_DESK}
          text={labels?.SUBTITLE_EVO_HELP_DESK}
          onPress={goToHelpDesk}
          hasIconInternal={false}
          hasIconEvoluno={true}
          backgroundColor={'#D1E7FB'}
        />


      </ScrollView >
    </View >
  );
});


const styles = StyleSheet.create({
  flex: { flex: 1 },
  glass: {
    width: 100,
    height: 100,
  },
  glassContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },


}
);

